export default __webpack_public_path__ + "static/media/facebook.b175a3a2.svg";